module.exports = __webpack_public_path__ + "static/img/LUCAS-IMPEY.3603874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUCAS-IMPEY.jpg
// module id = QdYc
// module chunks = 0